module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.loading) ? _c('div', {
    staticClass: "c-box"
  }, [_c('loader', {
    attrs: {
      "loading": _vm.sending,
      "label": _vm.getCountVariations()
    }
  }), _vm._v(" "), _c('header', {
    staticClass: "c-box__heading",
    class: {
      disabledHeader: _vm.product.status === 'cannotSend'
    },
    on: {
      "click": function($event) {
        return _vm.toggleProductInfo()
      }
    }
  }, [_vm._m(0), _vm._v(" "), _c('i', {
    staticClass: "u-floatRight icon",
    class: _vm.toggleIconClass()
  }), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "header-right"
    },
    slot: "header-right"
  }, [(_vm.isProductStatusNotSending) ? _c('span', {
    staticClass: "badge u-floatRight status",
    class: _vm.product.status
  }, [_vm._v(_vm._s(_vm.productStatusLabel))]) : _vm._e(), _vm._v(" "), _vm._t("header-right")], 2)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show && !_vm.everyVariationWithErrorOrSent),
      expression: "show && !everyVariationWithErrorOrSent"
    }],
    staticClass: "c-box__body"
  }, [_c('div', {
    staticClass: "c-box__inner"
  }, [(_vm.product) ? _c('panel', {
    attrs: {
      "title": "Informações gerais do produto"
    }
  }, [_c('div', {
    attrs: {
      "slot": "header-right"
    },
    slot: "header-right"
  }, [_c('button', {
    staticClass: "hint hint--left btn btn--info",
    class: {
      'is-loading': _vm.addingImage
    },
    attrs: {
      "slot": "header-actions",
      "disabled": _vm.addingImage,
      "data-label": "Adicionar uma imagem em uma ou mais variações"
    },
    on: {
      "click": function($event) {
        _vm.addingImage = true
      }
    },
    slot: "header-actions"
  }, [_vm._v("\n            Adicionar Imagem\n          ")]), _vm._v(" "), _c('modal-add-image', {
    attrs: {
      "visible": _vm.addingImage,
      "variations": _vm.product.variations,
      "callback": _vm.uploadedImage,
      "module": _vm.moduleUploadImageModal
    },
    on: {
      "close": function (close) { return _vm.addingImage = close; }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "l-row"
  }, [_c('form-group', {
    attrs: {
      "slot": "product",
      "label": "Título",
      "columns": 12,
      "error": _vm.getError('title', _vm.product.productId),
      "required": true
    },
    slot: "product"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.title),
      expression: "product.title"
    }],
    staticClass: "form-input",
    attrs: {
      "type": "text",
      "disabled": _vm.disabledInput('title')
    },
    domProps: {
      "value": (_vm.product.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.product, "title", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.maxTitleLengthDI !== null) ? _c('small', {
    staticClass: "form-help",
    class: _vm.titleLength
  }, [_vm._v(_vm._s(_vm.getTitleLengthLabel()))]) : _vm._e()]), _vm._v(" "), _c('form-group', {
    attrs: {
      "slot": "product",
      "label": "Descrição",
      "columns": 12,
      "error": _vm.getError('description', _vm.product.productId),
      "required": true
    },
    slot: "product"
  }, [(_vm.allowDescriptionHtml) ? _c('quill-editor', {
    attrs: {
      "options": {
        placeholder: 'Adicione a descrição do seu produto aqui'
      },
      "disabled": _vm.disabledInput('description')
    },
    model: {
      value: (_vm.product.description),
      callback: function($$v) {
        _vm.$set(_vm.product, "description", $$v)
      },
      expression: "product.description"
    }
  }) : _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.description),
      expression: "product.description"
    }],
    staticClass: "form-textarea",
    attrs: {
      "rows": "8",
      "options": {
        placeholder: 'Adicione a descrição do seu produto aqui'
      },
      "disabled": _vm.disabledInput('description')
    },
    domProps: {
      "value": (_vm.product.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.product, "description", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.maxDescriptionLengthDI !== null) ? _c('small', {
    staticClass: "form-help",
    class: _vm.descriptionLength
  }, [_vm._v(_vm._s(_vm.getDescriptionLengthLabel()))]) : _vm._e()], 1), _vm._v(" "), _vm._t("default")], 2), _vm._v(" "), _c('div', {
    staticClass: "l-row"
  }, [_c('form-group', {
    attrs: {
      "slot": "product",
      "label": "Marca",
      "columns": 3,
      "error": _vm.getError('brand', _vm.product.productId),
      "required": true
    },
    slot: "product"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.brand),
      expression: "brand"
    }],
    staticClass: "form-select",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.brand = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.onChangeAttribute('brand', _vm.brand)
      }]
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v(_vm._s(_vm.$t('choose.label')) + " ")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "custom"
    }
  }, [_vm._v("Adicionar personalizada")]), _vm._v(" "), _vm._l((_vm.brands), function(brand) {
    return _c('option', {
      key: brand,
      domProps: {
        "value": brand
      }
    }, [_vm._v(_vm._s(brand))])
  })], 2), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.customBrand) ? _c('editable', {
    attrs: {
      "value": "",
      "isEditable": true,
      "onConfirm": function (a, b) { return _vm.onConfirmAttribute(a, b, 'brand'); },
      "onCancel": function () { return _vm.onCancelAttribute('brand'); }
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": _vm.$t('category.label'),
      "error": _vm.getError('typeVariation', _vm.product.productId),
      "required": true
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.category),
      expression: "category"
    }],
    staticClass: "form-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.category = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v(_vm._s(_vm.$t('choose.label')))]), _vm._v(" "), _vm._l((_vm.categories), function(category) {
    return _c('option', {
      key: category,
      domProps: {
        "value": category.name
      }
    }, [_vm._v(_vm._s(category.name))])
  })], 2)]), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": _vm.$t('typeVariation.label'),
      "error": _vm.getError('typeVariations', _vm.product.productId),
      "required": true
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.typeVariations),
      expression: "typeVariations"
    }],
    staticClass: "form-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.typeVariations = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("Selecione")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "none"
    }
  }, [_vm._v("Sem variação")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "color"
    }
  }, [_vm._v("Cor")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "size"
    }
  }, [_vm._v("Tamanho")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "voltage"
    }
  }, [_vm._v("Voltagem")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "colorsize"
    }
  }, [_vm._v("Cor e Tamanho")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "colorvoltage"
    }
  }, [_vm._v("Cor e Voltagem")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "sizevoltage"
    }
  }, [_vm._v("Tamanho e Voltagem")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "colorsizevoltage"
    }
  }, [_vm._v("Cor, Tamanho e Voltagem")])])]), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": _vm.$t('warranty.label'),
      "required": true,
      "error": _vm.getError('warrantyTime', _vm.product.productId)
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.warrantyTime),
      expression: "product.warrantyTime"
    }],
    staticClass: "form-input",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.product.warrantyTime)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.product, "warrantyTime", $event.target.value)
      }
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "l-row"
  }, [_c('form-group', {
    attrs: {
      "label": _vm.$t('ncm.label'),
      "error": _vm.getError('ncm', _vm.product.productId)
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.ncm),
      expression: "product.ncm"
    }],
    staticClass: "form-input",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.product.ncm)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.product, "ncm", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": _vm.$t('crossDocking.label'),
      "error": _vm.getError('crossDocking', _vm.product.productId)
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.crossDocking),
      expression: "crossDocking"
    }],
    staticClass: "form-input",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.crossDocking)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.crossDocking = $event.target.value
      }
    }
  }), _vm._v(" "), _c('small', {
    staticClass: "form-help"
  }, [_vm._v(" (Em dias)")])])], 1)]) : _vm._e(), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "l-row vertical-flex"
  }, _vm._l((_vm.product.variations), function(variation) {
    return _c('div', {
      key: variation,
      staticClass: "l-col-12@md"
    }, [_c(_vm.marketplaceVariationProvide, {
      ref: "product.variations",
      refInFor: true,
      tag: "component",
      attrs: {
        "fromModule": _vm.fromModule,
        "toModule": _vm.toModule,
        "variation": variation
      }
    })], 1)
  }), 0)], 1)])], 1) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_vm._v(_vm._s(_vm.product.title))])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "divider"
  }, [_c('span', [_vm._v("Informações das variações do produto")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-029b4b21","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/marketplace/sicredi/provide/Product.vue
// module id = 2869
// module chunks = 0